import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styles } from "../style/FoundryStyle";
import { SCREEN_IDS } from "../components/FullComponent.js";
import NewCronometro from "../components/Cronometros/ComponentCronometro";
import OptionsCalidad from "../components/Calidad/ComponentCalidad";
import {
  getMOForMultipleWork,
  getListProcesos,
} from "../services/ConnectDataBase";
import { updateListaPesos } from "../redux/reducers";
import ImageDetailsComponent from "../components/Info/ComponentDetalles.js";
import { LinearGradient } from "expo-linear-gradient";
import { backgroundColor } from "../constants/Constants.js";
import { translateText } from "../translations/translationService";
import {
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  CircularProgress,
  TextField,
} from "@mui/material";
import { MULTIPLE_MO_WORK_COLORS } from "../style/colors.js";

export default function MultipleMOWork() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const scanInputRef = useRef(null);
  const screenName = "MultipleMOWork";
  const lang = useSelector((state) => state.lang.value);
  const currentScreenId = SCREEN_IDS.MULTIPLE_WORK;
  const listData = useSelector((state) => state.pesosList.listaPesos);
  const [refSearch, setRefSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedDescriptionOption, setSelectedDescriptionOption] =
    useState("");
  const [listProcesos, setListProcesos] = useState([]);
  const team = useSelector((state) => state.user.team);

  useEffect(() => {
    optionList();
  }, []);

  useEffect(() => {
    dispatch(updateListaPesos([]));
    setRefSearch("");
  }, []);

  const optionList = async () => {
    try {
      const listProcessOption = await getListProcesos(
        screenName,
        0,
        currentScreenId
      );
      const moArray = Object.entries(listProcessOption).map(([po, mo]) => ({
        key: po,
        po,
        ...mo,
      }));
      setListProcesos(moArray);
    } catch (error) {
      console.error(error);
    }
  };

  const getMo = async () => {
    const codesArray = refSearch
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
    if (codesArray.length === 0) return;

    setIsLoading(true);
    try {
      const fullMo = await getMOForMultipleWork(
        screenName,
        0,
        currentScreenId,
        codesArray
      );
      const moArray = Object.entries(fullMo).map(([po, mo]) => ({
        key: po,
        po,
        ...mo,
      }));
      setIsLoading(false);
      dispatch(updateListaPesos(moArray));
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleInputChange = (e) => {
    let value = e.target.value.replace(/'/g, "-");

    const codes = value.split(",").map((code) => code.trim());
    const lastCode = codes[codes.length - 1];
    const regex = /^\d{6}-\d{3}$/;

    if (regex.test(lastCode)) {
      codes[codes.length - 1] = lastCode;
      setRefSearch(codes.join(", ") + ", ");
    } else {
      setRefSearch(value);
    }
  };

  const renderButtonsAndCounter = (mo) => (
    <Box display='flex' flexDirection='row'>
      <NewCronometro
        numPiezas={mo.cantidad}
        mo={mo}
        proceso={selectedDescriptionOption}
        currentScreenId={currentScreenId}
        codProceso={selectedOption}
      />
    </Box>
  );

  const renderCalidadOptions = (mo) => (
    <Box display='flex' flexDirection='row'>
      <OptionsCalidad mo={mo} currentScreenId={currentScreenId} />
    </Box>
  );

  const renderItem = ({ item }) => {
    const content =
      team === "Control de calidad" || team === "Jefe de taller"
        ? renderCalidadOptions(item)
        : renderButtonsAndCounter(item);

    return (
      <Box
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent='space-between'
        p={1}
        sx={{
                          backgroundColor: MULTIPLE_MO_WORK_COLORS.BACKGROUND_TABLE_HEADER,
          borderBottom: "1px solid lightgrey",
        }}
        overflow='hidden'>
        <ImageDetailsComponent imageUrl={item.imagen} mo={item} />
        <Typography sx={""}>{item.po}</Typography>
        <Typography sx={""}>{item.mo}</Typography>
        <Typography sx={""}>{item.cantidad}</Typography>
        <Typography sx={""}>{item.referencia}</Typography>
        <Typography sx={""}>
          {item.fechaentrega?.date.split(" ")[0] || "Fecha no disponible"}
        </Typography>
        <Typography sx={""}>{item.stamping}</Typography>
        {content}
      </Box>
    );
  };

  const renderList = () => {
    if (listData.length === 0) {
      return (
        <Typography variant='body1' align='center' color='textSecondary'>
          No data to display...
        </Typography>
      );
    }

    return listData.map((item) => renderItem({ item }));
  };

  return (
    <LinearGradient colors={backgroundColor()} style={styles.containerNoColor}>
      <Box
        flexDirection='column'
        alignItems='center'
        sx={{
          padding: 2,
        }}>
        <Box
          display='flex'
          flexDirection='row'
          alignItems='center'
          width='100%'
          mb={2}>
          <TextField
            inputRef={scanInputRef}
            variant='outlined'
            placeholder={translateText("Código de MO", lang)}
            value={refSearch}
            onChange={handleInputChange}
            sx={{ flex: 2, marginRight: 2 }}
          />
          <Select
            value={selectedOption}
            onChange={(e) => {
              setSelectedOption(e.target.value);
              const selectedDescription =
                listProcesos.find((option) => option.codigo === e.target.value)
                  ?.descripcion || "";
              setSelectedDescriptionOption(selectedDescription);
            }}
            displayEmpty
            sx={{ flex: 1, marginRight: 2 }}>
            <MenuItem value='' disabled>
              {translateText("Seleccionar proceso", lang)}
            </MenuItem>
            {listProcesos.map((option) => (
              <MenuItem key={option.key} value={option.codigo}>
                {option.descripcion}
              </MenuItem>
            ))}
          </Select>
          <Button variant='contained' color='primary' onClick={getMo}>
            {translateText("Actualizar", lang)}
          </Button>
        </Box>

        {isLoading ? (
          <CircularProgress color='secondary' />
        ) : (
          <Box display='flex' flexDirection='column' width='100%'>
            {renderList()}
          </Box>
        )}
      </Box>
    </LinearGradient>
  );
}
